import styled from 'styled-components';

// Lista de desvios do padrao — tokens CCO. Severidade: warn=orange,
// critical=red (mesma semantica do resto do sistema).
const sevColor = (props) =>
  props.$severity === 'critical' ? 'var(--cco-red)' : 'var(--cco-orange)';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Empty = styled.div`
  font-size: 13px;
  color: var(--cco-ink-faint);
  line-height: 1.5;
  padding: 4px 0;
`;

export const Ok = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--cco-green);
  padding: 4px 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
  border-left: 3px solid ${sevColor};
`;

export const RowHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
`;

export const VarName = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: var(--cco-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ZBadge = styled.span`
  flex-shrink: 0;
  padding: 2px 9px;
  border-radius: 999px;
  background: ${sevColor};
  color: #1a1208;
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const RowVals = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
`;

export const Current = styled.span`
  font-size: 15px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: ${sevColor};
`;

export const Typical = styled.span`
  font-size: 11.5px;
  font-weight: 600;
  color: var(--cco-ink-faint);
  font-variant-numeric: tabular-nums;
`;
